import React, { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGeneratorContext } from '../contexts/GeneratorStateContext';
import { useNotification, NOTIFICATION } from '../components/NotificationSystem';
import { fetchShare } from '../services/shareApi';
import { localGenPath } from '../utils/buildRoutes';
import './ShareOpen.css';

const TXT_LOADING = { fr: 'Chargement du stuff partagé…', en: 'Loading shared build…', de: 'Geteilter Build wird geladen…', es: 'Cargando la build compartida…', pt: 'Carregando a build compartilhada…' };
const TXT_OK = { fr: 'Stuff chargé', en: 'Build loaded', de: 'Build geladen', es: 'Build cargada', pt: 'Build carregada' };
const TXT_FAIL = { fr: 'Lien invalide ou expiré', en: 'Invalid or expired link', de: 'Ungültiger oder abgelaufener Link', es: 'Enlace no válido o caducado', pt: 'Link inválido ou expirado' };

const ShareOpen = () => {
    const { lang, slug } = useParams();
    const navigate = useNavigate();
    const { importState } = useGeneratorContext();
    const { showNotification } = useNotification();
    const importStateRef = useRef(importState);
    importStateRef.current = importState;

    useEffect(() => {
        let cancelled = false;

        async function run() {
            try {
                const state = await fetchShare(slug);
                if (cancelled) return;
                const ok = await importStateRef.current(JSON.stringify(state));
                if (!ok) throw new Error('import');
                showNotification(TXT_OK[lang] || TXT_OK.en, NOTIFICATION.SUCCESS);
                navigate(localGenPath(lang), { replace: true });
            } catch {
                if (cancelled) return;
                showNotification(TXT_FAIL[lang] || TXT_FAIL.en, NOTIFICATION.ERROR);
                navigate(localGenPath(lang), { replace: true });
            }
        }

        run();
        return () => {
            cancelled = true;
        };
    }, [slug, lang, navigate, showNotification]);

    return (
        <div className="share-open column center">
            <p className="share-open-msg">{TXT_LOADING[lang] || TXT_LOADING.en}</p>
        </div>
    );
};

export default ShareOpen;
